<template>
  <div id="login" class="animated fadeIn fast">
    <el-form :model="recoverForm" status-icon :rules="rules" ref="recoverForm">
      <img src="@/assets/images/logo_login.png" />
      <el-form-item prop="email">
        <el-input
          type="email"
          v-model="recoverForm.email"
          autocomplete="off"
          placeholder="Introduce tu email"
        ></el-input>
      </el-form-item>
      <el-form-item style="text-align: center">
        <button class="btn" @click="submit">
          Recordar contraseña
        </button>
      </el-form-item>
      <el-link class="secondary" @click="$router.push({ name: 'login' })"
        >Volver</el-link
      >
    </el-form>
    <Modal
      v-if="showModal"
      :size="'small'"
      :theme="'white'"
      @close="showModal = false"
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>
            Si su dirección de email estaba dada de alta, se le enviará un
            correo con su nueva contraseña
          </label>
          <div class="row">
            <div class="col-12 text-center">
              <button
                class="btn"
                style="margin: 20px 0px"
                @click="
                  showModal = false;
                  $router.push({ name: 'login' });
                "
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import UserService from "@/services/user.service";

// Components
import Modal from "@/components/Modal";

export default {
  name: "Recover",
  components: { Modal },
  data() {
    return {
      showModal: false,
      recoverForm: {
        email: null
      },
      rules: {
        email: {
          type: "email",
          required: true,
          message: "Por favor introduce un email válido",
          trigger: "blur"
        }
      }
    };
  },
  methods: {
    submit() {
      this.$refs["recoverForm"].validate(valid => {
        if (valid) {
          const loadingInstance = Loading.service({ fullscreen: true });
          UserService.rememberPassword(this.recoverForm.email)
            .then(() => {
              loadingInstance.close();
              this.showModal = true;
            })
            .catch(error => {
              loadingInstance.close();
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/sass/styles";
#login {
  position: absolute;
  top: 0;
  left: 28%;
  width: 380px;
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: rgba(252, 252, 252, 0.3);
  padding: 0px 40px;
  overflow-y: auto;
  img {
    width: 100%;
    margin-bottom: 50px;
  }
  form {
    .el-input__inner {
      border-radius: 50px !important;
      color: $pink-color;
      font-weight: 600;
      &::placeholder {
        color: $pink-color;
        opacity: 1;
      }
    }
    .el-form-item__error {
      color: $white-color;
    }
    button {
      height: 50px;
      width: 100%;
    }
    span {
      color: $white-color;
    }
    .el-link {
      border: none;
      margin-bottom: 30px;
      &::after {
        border: none;
      }
      .el-link--inner {
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 720px) {
  #login {
    left: 0;
    right: 0;
  }
}
@media (max-width: 400px) {
  #login {
    width: 100%;
    padding: 0px 40px;
  }
}

@media (max-height: 450px) {
  #login {
    form {
      height: 100%;
      padding-top: 50px;
    }
  }
}
</style>
